const c = async (e, n = 1e3, o = 50) => {
  const i = Date.now();
  return new Promise((r, s) => {
    const t = () => {
      e() ? r() : Date.now() - i >= n ? s(new Error("Condition not met within timeout")) : setTimeout(t, o);
    };
    t();
  });
};
export {
  c as waitUntilTrue
};
